import type { FinancialChartDatum } from "../types/financialUi"

export const FINANCIAL_CHART_COLORS = ["#f97316", "#10b981", "#3b82f6", "#8b5cf6", "#f59e0b", "#ef4444"] as const

export const FINANCIAL_CHART_RESIZE_DEBOUNCE_MS = 240

const normalizeChartValue = (value: number) => (Number.isFinite(value) && value > 0 ? value : 0)

export const sanitizeFinancialSeries = (data: readonly FinancialChartDatum[]): FinancialChartDatum[] =>
  data.map((item, index) => ({
    ...item,
    value: normalizeChartValue(item.value),
    secondaryValue: item.secondaryValue === undefined ? undefined : normalizeChartValue(item.secondaryValue),
    color: item.color ?? FINANCIAL_CHART_COLORS[index % FINANCIAL_CHART_COLORS.length],
  }))

export const limitFinancialRanking = (
  data: readonly FinancialChartDatum[],
  limit = 10,
): FinancialChartDatum[] =>
  sanitizeFinancialSeries(data)
    .map((item, index) => ({ item, index }))
    .sort((first, second) => second.item.value - first.item.value || first.index - second.index)
    .slice(0, Math.max(0, limit))
    .map(({ item }) => item)

export const hasFinancialChartData = (data: readonly FinancialChartDatum[]) =>
  data.some((item) => normalizeChartValue(item.value) > 0 || normalizeChartValue(item.secondaryValue ?? 0) > 0)
